import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let AdminController = {
    selectSchool: (schoolId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/admin/select-school/${schoolId}`,
            method: 'POST',
        }, callback);

    },
    adminEditUser: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/admin/admin-edit-user`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
}

export default AdminController
